// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2Qwzo","search":"Settings_search__3xF1z","filter":"Settings_filter__2wMmp"};